export const PORTER_PASSWORD_LENGTH = 4;
